import { render, staticRenderFns } from "./awssimulatekillingavailabilityzone.md?vue&type=template&id=33f78e93"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports